export enum OasisAssessmentStatusEnum {
  WaitingForComprehensiveAssessment = 1,
  Performing = 2,
  Performed = 3,
  PerformingCollaboration = 4,
  InReview = 5,
  ReadyToExport = 6,
  Exporting = 7,
  Exported = 8,
  ExportFailed = 9,
  Accepted = 10,
  Rejected = 11
}

export const OasisAssessmentStatusOptions = [
{ id: 1, label: 'Waiting for Comprehensive Assessment', initialAssessmentPerformed: false, canBeReviewed: false, canBeExported: false },
{ id: 2, label: 'Performing', initialAssessmentPerformed: false, canBeReviewed: false, canBeExported: false },
{ id: 3, label: 'Performed', initialAssessmentPerformed: true, canBeReviewed: true, canBeExported: false },
{ id: 4, label: 'Performing Collaboration', initialAssessmentPerformed: true, canBeReviewed: true, canBeExported: false },
{ id: 5, label: 'In Review', initialAssessmentPerformed: true, canBeReviewed: false, canBeExported: false },
{ id: 6, label: 'Ready to export', initialAssessmentPerformed: true, canBeReviewed: false, canBeExported: true },
{ id: 7, label: 'Exporting', initialAssessmentPerformed: true, canBeReviewed: false, canBeExported: false },
{ id: 8, label: 'Exported', initialAssessmentPerformed: true, canBeReviewed: false, canBeExported: true },
{ id: 9, label: 'Export Failed', initialAssessmentPerformed: true, canBeReviewed: false, canBeExported: true },
{ id: 10, label: 'Accepted', initialAssessmentPerformed: true, canBeReviewed: false, canBeExported: true },
{ id: 11, label: 'Rejected', initialAssessmentPerformed: true, canBeReviewed: false, canBeExported: true }
];
